import React, { memo } from 'react';
import { Blok } from '../../../interfaces/Blok.interface';
import PreNavProps from './PreNav.interface';
import PreNavDropdown from './PreNavDropdown/PreNavDropdown';
import { Theme } from '../../../interfaces/enums/Theme.enum';
import { withBlokWrapper } from '../../BlokWrapper/BlokWrapper';
import { ButtonSize } from '../../../interfaces/enums/ButtonSize.enum';
import CustomLink from '../../CustomLink/CustomLink';
import { StoryblokComponent } from 'gatsby-source-storyblok';
import { pushToDataLayer } from '../../../utils/pushToDataLayer/pushToDataLayer.util';

const PreNav: React.FC<PreNavProps> = ({
  pre_navigation_items,
  secondary_cta,
}) => {
  return (
    <section className="hidden xl:block bg-surface/background">
      <nav
        className="flex items-center justify-end container mx-auto"
        aria-label="pre navigation"
      >
        <ul className="flex space-x-8 pr-10">
          {pre_navigation_items &&
            !!pre_navigation_items.length &&
            pre_navigation_items.map(
              (item) =>
                item.label && (
                  <li
                    key={item._uid}
                    className="relative flex items-center group"
                  >
                    <CustomLink
                      url={item.link?.cached_url}
                      label={item.label}
                      className="flex justify-center items-center group h-[66px] nav-link"
                    >
                      <span className="text-text/body group-hover:text-text/body-accent text-sm">
                        {item.label}
                      </span>
                      {!!item.dropdown.length && (
                        <span
                          className="h-[24px] w-[24px] bg-no-repeat group-hover:rotate-180 bg-text/body group-hover:bg-text/body-accent transition-all ease-in-out"
                          style={{
                            WebkitMaskImage: "url('/svgs/chevron.svg')",
                            maskImage: "url('/svgs/chevron.svg')",
                          }}
                        />
                      )}
                    </CustomLink>
                    {!!item.dropdown?.length && (
                      <PreNavDropdown dropdown={item.dropdown} />
                    )}
                  </li>
                )
            )}
        </ul>
        <div className="flex-0">
          {secondary_cta.map((cta: Blok) => (
            <StoryblokComponent
              blok={{ ...cta, size: ButtonSize.MD }}
              key={cta._uid}
            />
          ))}
        </div>
      </nav>
    </section>
  );
};

export default memo(withBlokWrapper(PreNav, Theme.DARKEST));
